import { Tooltip } from '@heroui/react'
import { Info } from 'lucide-react'
import { ProgressBar } from '../../ui/ProgressBar'

interface MetricValueProps {
  label: string
  value: number | undefined | null
  hoverLabel?: string
  checkpoints: { medium: number, high: number, max: number }
  flipped?: boolean
  tooltip?: string
  showValueInLabel?: boolean
}

export function MetricValue({
  label,
  value,
  hoverLabel,
  checkpoints,
  flipped,
  tooltip,
  showValueInLabel,
}: MetricValueProps) {
  if (value === undefined || value === null)
    return undefined

  const percentage = (value / checkpoints.max) * 100

  const getColor = () => {
    const { medium, high } = checkpoints

    if (flipped) {
      if (value <= high)
        return 'oklch(70.4% 0.191 22.216)' // red
      if (value <= medium)
        return 'oklch(83.7% 0.128 66.29)' // yellow
    }
    else {
      if (value >= high)
        return 'oklch(70.4% 0.191 22.216)' // red
      if (value >= medium)
        return 'oklch(83.7% 0.128 66.29)' // yellow
    }

    return undefined
  }

  const content = (
    <div className="flex flex-col gap-2">
      <span className="flex items-center gap-1 text-xs capitalize">
        {showValueInLabel
          ? `${value} ${label}${value === 1 ? '' : 's'}`
          : label}
        {tooltip && (
          <Tooltip
            content={tooltip}
            className="rounded-sm"
            classNames={{ content: 'max-w-xs' }}
          >
            <Info className="h-3 w-3 text-gray-600" />
          </Tooltip>
        )}
      </span>
      <ProgressBar value={percentage} color={getColor()} />
    </div>
  )

  if (hoverLabel) {
    return (
      <Tooltip content={hoverLabel} className="rounded-sm">
        {content}
      </Tooltip>
    )
  }

  return content
}
